module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAGCAYAAAAPDoR2AAAAeElEQVQYV2PUavjPJsf4LPbXL8Y9+1qlHjIgAUbPhrd8/xm+d/9jYPjPyMB4hukn08bt7ZKvQWrgkggNjH8YGBgOP2KQWodFEqSF8c7nr59noEn+f/6fiXH9zjqZi2BjLQsfc/LxM1T8+8u0azfz7OMMDQ3/YFYAALdxNkzFUCKFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/set_img/icon_sj_blue.png
// module id = 765
// module chunks = 1